<script setup lang="ts">
import type { Editor } from '@tiptap/vue-3'
import ActionButton from '@/notebook/components/ActionButton.vue'
import { type icons } from '@/notebook/components/icons'
import type { ButtonViewReturnComponentProps } from '@/notebook/type'
import type { CreateTablePayload } from './CreateTablePopover.vue'
import CreateTablePopover from './CreateTablePopover.vue'

type Props = {
  editor: Editor
  icon?: keyof typeof icons
  tooltip?: string
  disabled?: boolean
  color?: string
  action?: ButtonViewReturnComponentProps['action']
  isActive?: ButtonViewReturnComponentProps['isActive']
}

const props = withDefaults(defineProps<Props>(), {
  icon: undefined,
  tooltip: undefined,
  disabled: false,
  color: undefined,
  action: undefined,
  isActive: undefined,
})

function createTable(options: CreateTablePayload) {
  if (!props.disabled) {
    props.editor
      .chain()
      .focus()
      .insertTable({ ...options, withHeaderRow: false })
      .run()
  }
}
</script>

<template>
  <CreateTablePopover :disabled="disabled" @create-table="createTable">
    <template #trigger>
      <div style="display: flex">
        <ActionButton
          :icon="icon"
          :tooltip="tooltip"
          :disabled="disabled"
          :color="color"
          :action="action"
          :is-active="isActive"
        >
        </ActionButton>
      </div>
    </template>
  </CreateTablePopover>
</template>
